/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentCourseExamTryViewModel } from "../types/StudentCourseExamTryViewModel.ts";

export const studentCourseExamTryViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da tentativa de realização da prova."),
  ),
  dateStart: z.optional(
    z.string().datetime().describe("Data e hora de início da tentativa."),
  ),
  dateEnd: z
    .string()
    .datetime()
    .describe("Data e hora de término da tentativa. Opcional.")
    .nullish(),
  grade: z
    .number()
    .describe("Nota obtida nesta tentativa. Opcional.")
    .nullish(),
  environment: z.optional(
    z
      .number()
      .int()
      .describe("Código do ambiente em que a tentativa foi realizada."),
  ),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do registro. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do registro. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação do registro.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração do registro.")
    .nullish(),
}) as unknown as ToZod<StudentCourseExamTryViewModel>;
